import React, { useEffect, useRef } from 'react'
import icons from '../../assets/images/sprite-other-icons.svg'
import Wallet from '../../assets/images/wallet .svg'
import JaqkCoin from '../../assets/images/jaqk-coin.svg'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import LoyaltyConfig from '../../assets/loyaltyPointsConfig.json'

const Profile = () => {
  const { balance, userDetails, userLoyalty } = useSelector(
    state => state?.signIn
  )
  // const topRef = useRef(null)
  // useEffect(() => {
  //   topRef.current.scrollIntoView(true)
  // }, [])
  return (
    <div className='SB-page-content'>
      <div className='SB-myAccountSection-container SB-profile'>
        <div className='SB-pageHeader'>
          <div className='SB-pageHeader-title'>Profile</div>
        </div>
        <div className='SB-content'>
          <div className='SB-myAccountBalance-container'>
            <div className='SB-userMobileNumber d-none'>
              <b id='userPhoneNumber'>{userDetails?.userOtherInfo?.phone}</b>
            </div>
            <div className='SB-userProfile'>
              <div className='SB-usericon'>
                <div className='SB-icon-container SB-iconSVG'>
                  <svg xmlns='http://www.w3.org/2000/svg'>
                    <use xlinkHref={`${icons}#${'icon-user-avatar'}`}></use>
                  </svg>
                </div>
                {/* <div className='SB-icon-container SB-icon-edit d-none'>
                  <div className='SB-iconSVG' title='edit'>
                    <svg xmlns='http://www.w3.org/2000/svg'>
                      <use xlinkHref='images/sprite-other-icons.svg#icon-edit'></use>
                    </svg>
                  </div>
                </div> */}
              </div>
              <div className='SB-userDetails'>
                <div className='SB-userNumber'>
                  {userDetails?.userOtherInfo?.phone}
                </div>
                {/* <div className='SB-userName d-none'>John</div> */}
              </div>
            </div>

            <div className='SB-myAccount-sectionBox_content'>
              <div className='SB-coinsItem-group'>
                <div className='SB-coinsItem'>
                  <div className='SB-coinsItem-label'>Account Balance</div>
                  <div className='SB-coinsItem-value'>
                    <img src={Wallet} alt='wallet' />
                    <span>KES {balance?.toLocaleString()}</span>
                  </div>
                </div>
                <div className='SB-coinsItem SB-coinsBalance'>
                  <div className='SB-coinsItem-label'>FasFas Coins Balance</div>
                  <div className='SB-coinsItem-value'>
                    <img src={JaqkCoin} alt='jaqk-coin' />
                    <span>
                      {userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className='SB-userLevel'>
              <div
                className={`SB-userLevel-Card  ${
                  userLoyalty?.lifeTimeCoins <=
                  LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                    .levelCutoff
                    ? 'step-1'
                    : userLoyalty?.lifeTimeCoins <=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                        .levelCutoff
                    ? 'step-2'
                    : userLoyalty?.lifeTimeCoins <=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                        .levelCutoff
                    ? 'step-3'
                    : userLoyalty?.lifeTimeCoins <=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                        .levelCutoff
                    ? 'step-4'
                    : userLoyalty?.lifeTimeCoins >=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                        .levelEntry
                    ? 'step-5 vipImg'
                    : ''
                }`}
              >
                <div className='SB-userLevel-Badge'>
                  {userLoyalty?.lifeTimeCoins <=
                  LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                    .levelCutoff ? (
                    <img
                      src={require('../../assets/images/loyalty/dash.webp')}
                       alt='dash'
                    />
                  ) : userLoyalty?.lifeTimeCoins <=
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                      .levelCutoff ? (
                    <img
                      src={require('../../assets/images/loyalty/sprint.webp')}
                       alt='sprint'
                    />
                  ) : userLoyalty?.lifeTimeCoins <=
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                      .levelCutoff ? (
                    <img
                      src={require('../../assets/images/loyalty/surge.webp')}
                       alt='surge'
                    />
                  ) : userLoyalty?.lifeTimeCoins <=
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                      .levelEntry ? (
                    <img
                      src={require('../../assets/images/loyalty/thrill.webp')}
                       alt='thrill'
                    />
                  ) : userLoyalty?.lifeTimeCoins >=
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                      .levelEntry ? (
                    <img
                      src={require('../../assets/images/loyalty/boss.webp')}
                       alt='boss'
                    />
                  ) : (
                    ''
                  )}
                </div>
                {userLoyalty.level === 'level4' ? (
                  <div className='SB-userLevel-Content'>
                    <div className='SB-userLevel-Heading'>
                      Congratulations!
                      <p>You've reached the BOSS level!</p>
                    </div>
                    <div className='SB-userLevel-points'>
                      Available Loyalty Coins
                      <span>
                        <img src={JaqkCoin} alt='coin' />
                        {Math.floor(userLoyalty?.coins).toLocaleString()}
                      </span>
                    </div>
                    <div className='SB-userLifeTime-points'>
                      Lifetime Loyalty Coins
                      <span>
                        <img src={JaqkCoin} alt='coin' />
                        {Math.floor(userLoyalty?.lifeTimeCoins).toLocaleString()}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className='SB-userLevel-Content'>
                    <div className='SB-userLevel-points'>
                      Loyalty Coins
                      <span>
                        <img src={JaqkCoin} alt='coin' />
                        {userLoyalty?.lifeTimeCoins
                          ? Math.floor(userLoyalty?.lifeTimeCoins).toLocaleString()
                          : 0}
                      </span>
                    </div>

                    <p>
                      Earn{' '}
                      {userLoyalty?.lifeTimeCoins <
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                        .levelEntry
                        ? LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .levelEntry
                        : userLoyalty?.lifeTimeCoins <
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .levelEntry
                        ? LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .levelEntry
                        : userLoyalty?.lifeTimeCoins <
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                            .levelEntry
                        ? LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                            .levelEntry
                        : userLoyalty?.lifeTimeCoins <
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .levelEntry
                        ? LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .levelEntry
                        : ''}{' '}
                      Loyalty Coins to unlock the next Level
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className='SB-profileList'>
              <ul>
                <li className='bettingRulesItem'>
                  <Link to={'/responsibleGambling'} className='SB-profileList-item-link'>
                    <div className='SB-profileList-item'>
                      <div className='SB-icon-container SB-iconSVG'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-terms-and-conditions'}`}
                            ></use>
                          </svg>
                      </div>
                      <div className='SB-profileList-item-content'>
                       Responsible Gambling
                      </div>
                      <div className='SB-arrow-container'>
                        <div className='SB-iconSVG' title='Arrow Right'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-angle-arrow-right'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </Link>
                </li>
                {/* <Link to={'/bettingRules'}>
                  <li className='bettingRulesItem'>
                    <div className='SB-profileList-item'>
                      <div className='SB-icon-container'>
                        <div className='SB-iconSVG' title='Betting Rules'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-terms-and-conditions'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                      {/* <div className='SB-profileList-item-content'>Betting Rules</div> */}
                      {/* <Link
                        className='SB-profileList-item-content'
                        to={'/bettingRules'}
                      >
                        Betting Rules
                      </Link>
                      <div className='SB-arrow-container'>
                        <div className='SB-iconSVG' title='Arrow Right'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-angle-arrow-right'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </li>
                </Link> */} 
                {/* <Link to={'/privacyPolicy'}>
                  <li className='privacyPolicyItem'>
                    <div className='SB-profileList-item'>
                      <div className='SB-icon-container'>
                        <div className='SB-iconSVG' title='Privacy Policy'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-privacy-policy'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                      {/* <div className='SB-profileList-item-content'>
                      Privacy Policy
                    </div> */}
                      {/* <Link
                        className='SB-profileList-item-content'
                        to={'/privacyPolicy'}
                      >
                        Privacy Policy
                      </Link>
                      <div className='SB-arrow-container'>
                        <div className='SB-iconSVG ' title='Arrow Right'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-angle-arrow-right'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </li>
                </Link> */} 
                <li className='cookiesPolicyItem'>
                  <Link to={'/amlpolicy'} className='SB-profileList-item-link'>
                    <div className='SB-profileList-item'>
                      <div className='SB-icon-container SB-iconSVG'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-cookies-policy'}`}
                            ></use>
                          </svg>
                      </div>
                      <div className='SB-profileList-item-content'>
                        AML Policy
                      </div>
                      <div className='SB-arrow-container'>
                        <div className='SB-iconSVG ' title='Arrow Right'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-angle-arrow-right'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </Link>
                </li>
                {/* <Link to={'/cookiePolicy'}>
                  <li className='cookiesPolicyItem'>
                    <div className='SB-profileList-item'>
                      <div className='SB-icon-container'>
                        <div className='SB-iconSVG' title='Cookies Policy'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-cookies-policy'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                      {/* <div className='SB-profileList-item-content'>
                      Cookies Policy
                    </div> */}
                      {/* <Link
                        className='SB-profileList-item-content'
                        to={'/cookiePolicy'}
                      > */}
                        {/* {' '}
                        Cookies Policy
                      </Link> */}
                      {/* <div className='SB-arrow-container'>
                        <div className='SB-iconSVG ' title='Arrow Right'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-angle-arrow-right'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </li> */}
                {/* </Link> */} 
                {/* <Link to={'/terms-conditions'}>
                  <li className='termsconditionsItem'>
                    <div className='SB-profileList-item'>
                      <div className='SB-icon-container'>
                        <div className='SB-iconSVG' title='Terms Conditions'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-terms-and-conditions'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                      {/* <div className='SB-profileList-item-content'>
                      Terms and Conditions
                    </div> */}
                      {/* <Link
                        className='SB-profileList-item-content'
                        to={'/terms-conditions'}
                      >
                        Terms and Conditions
                      </Link>
                      <div className='SB-arrow-container'>
                        <div className='SB-iconSVG ' title='Arrow Right'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-angle-arrow-right'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </li>
                </Link> */} 
                {/* <Link to={'/faq'}>
                  <li className='faqItem'>
                    <div className='SB-profileList-item'>
                      <div className='SB-icon-container'>
                        <div className='SB-iconSVG' title='Terms Conditions'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use xlinkHref={`${icons}#${'icon-help'}`}></use>
                          </svg>
                        </div>
                      </div>
                      <Link className='SB-profileList-item-content' to={'/faq'}>
                        FAQ's
                      </Link>
                      <div className='SB-arrow-container'>
                        <div className='SB-iconSVG ' title='Arrow Right'>
                          <svg xmlns='http://www.w3.org/2000/svg'>
                            <use
                              xlinkHref={`${icons}#${'icon-angle-arrow-right'}`}
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </li>
                </Link> */}
              </ul>
            </div>
            {/* <div className='SB-myAccountSection SB-userDetails'>
              <div className='SB-myAccountSection-header'>Personal Details</div>
              <div className='SB-myAccountSection-content'>
                <div className='SB-row'>
                  <div className='SB-col'>
                    <div className='SB-form-group'>
                      <div className='SB-form-label'>First Name:</div>
                      <div className='SB-form-control'>
                        <input
                          id='accountFirstName'
                          disabled=''
                          type='text'
                          required=''
                          value='John'
                        />
                      </div>
                      <div className='SB-form-errorMsg'>
                        <span id='erroraccountFirstName'></span>
                      </div>
                    </div>
                  </div>
                  <div className='SB-col'>
                    <div className='SB-form-group'>
                      <div className='SB-form-label'>Last Name</div>
                      <div className='SB-form-control'>
                        <input
                          id='accountLastName'
                          readonly=''
                          type='text'
                          value='Smith'
                          required=''
                        />
                      </div>
                      <div className='SB-form-errorMsg'>
                        <span id='erroraccountLastName'></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='SB-row'>
                  <div className='SB-col'>
                    <div className='SB-form-group' id='SB-emailField'>
                      <div className='SB-form-label'>Email</div>
                      <div className='SB-form-control-group'>
                        <div className='SB-form-control'>
                          <input
                            id='accountEmail'
                            type='text'
                            disabled=''
                            required=''
                            placeholder='johnsmith@gmail.com'
                          />
                        </div>
                        <button
                          className='btn SB-btnPrimary active SB-btnLarge SB-btnVerify'
                          id='SB-btnEmailVerify'
                        >
                          Verify
                        </button>
                      </div>

                      <div className='SB-form-errorMsg'>
                        <span id='erroraccountEmail'></span>
                      </div>
                    </div>
                    <div
                      className='SB-verify-OTP'
                      id='SB-emailVerify'
                      style={{ display: 'none' }}
                    >
                      <div className='SB-form-group'>
                        <div className='SB-form-label SB-otp-label'>
                          Please enter the OTP (One Time Paasword) sent to email
                          id
                          <span>johnsmith@gmail.com</span>
                        </div>
                        <div className='SB-form-OTP-control'>
                          <div className='SB-form-control'>
                            <input type='text' placeholder='' required='' />
                            <input type='text' placeholder='' required='' />
                            <input type='text' placeholder='' required='' />
                            <input type='text' placeholder='' required='' />
                            <input type='text' placeholder='' required='' />
                            <input type='text' placeholder='' required='' />
                          </div>
                          <div className='SB-resend-container'>
                            <a href='' className='SB-ResendLink SB-disable1'>
                              Resend
                            </a>
                            <span>0:26 seconds</span>
                          </div>
                        </div>
                        <div
                          className='SB-form-errorMsg'
                          id='regMobileErrorMessage'
                        >
                          <span></span>
                        </div>
                      </div>
                      <button
                        className='btn SB-btnSecondary active SB-btnLarge SB-btn-verify'
                        id='SB-btnVerifyOTP'
                      >
                        Verify OTP
                      </button>
                      <div className='SB-space10'></div>
                    </div>
                    <div
                      className='SB-form-group'
                      id='SB-emailFieldVerified'
                      style={{ display: 'none' }}
                    >
                      <div className='SB-form-label'>Email</div>
                      <div className='SB-form-control-group SB-verified'>
                        <div className='SB-form-control'>
                          <input
                            type='text'
                            required=''
                            value='johnsmith@gmail.com'
                            disabled=''
                          />
                          <div
                            className='SB-form-addon SB-addon-right'
                            title='Verified'
                          >
                            <div className='SB-iconSVG'>
                              <svg xmlns='http://www.w3.org/2000/svg'>
                                <use
                                  xlinkHref={`${icons}#${'icon-verified'}`}
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='SB-form-errorMsg'>
                        <span id='erroraccountEmail'></span>
                      </div>
                    </div>
                  </div>
                  <div className='SB-col'>
                    <div className='SB-form-group'>
                      <div className='SB-form-label'>Date Of Birth:</div>
                      <div className='SB-form-control'>
                        <input
                          id='accountdob'
                          type='date'
                          required=''
                          value=''
                          placeholder='DD/MM/YYYY'
                        />
                      </div>
                      <div className='SB-form-errorMsg'>
                        <span id='erroraccountdob'></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='SB-msgBox' id='userProfileDetailsSaved'>
                  <div
                    className='SB-msgBox-container'
                    id='userProfileDetailsError'
                  >
                    Your details are updated successfully.
                  </div>
                </div>

                <button className='btn SB-btnSecondary active SB-btnSave'>
                  Save
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
